import { CSSProperties } from 'react';
import { StringKeyedDictionary } from '../../typescriptHelpers';
import { antGrey, runwayColors } from './globalStyles';

const styles: StringKeyedDictionary<React.CSSProperties> = {
    appContainer: {
        display: 'flex',
        width: '100%',
        height: '100%', // parent is not flex container so we need to explicitly set height
        backgroundColor: runwayColors.white,
    } as CSSProperties,
    loginContainer: {
        backgroundColor: antGrey.grey2,
    } as CSSProperties,
    centerVerticalAndHorizontal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    } as CSSProperties,
};

export default styles;
